class richText extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    let self = this
    // this.querySelector('.rich-text__heading')?.addEventListener('click', function() {
    //   self.openPopup(self);
    // });
    this.querySelector('.rich-text__text')?.addEventListener('click', function() {
      self.openPopup(self);
    });
    this.querySelector('.rich-text__text.rte')?.addEventListener('click', function() {
      self.openPopup(self);
    });
    this.querySelector('.btn-close-popup')?.addEventListener('click', function() {
      self.closePopup(self)
    });
  }

  openPopup(self) {
    if(self.querySelector('.rich-text-popup')) {
      self.querySelector('.rich-text-popup').classList.add('model-open');
    }
    document.querySelector('body').classList.add('not-scroll')
  }

  closePopup(self) {
    if(self.querySelector('.rich-text-popup')) {
      self.querySelector('.rich-text-popup').classList.remove('model-open');
    }
    document.querySelector('body').classList.remove('not-scroll')
  }
}
customElements.define('rich-text', richText)